import { FC, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import useInfraStores from '@app/hooks/useInfraStores';
import AuthenticatedMode from '@app/login/AuthenticatedMode';
import config from '@app/config';
import KnoxersManager from '@app/utils/knoxersManager';
import { isLocalhost } from '@app/utils/browserUtils';

export default function makeCanvasFlowLink(path: string): FC {
  return observer(() => {
    const { authenticationStore, userStore } = useInfraStores<AuthenticatedMode>();
    const history = useHistory();

    useEffect(() => {
      const canvasUrl = config.webUrls?.canvas;
      if (!canvasUrl) {
        console.error('Canvas URL not configured');
        return;
      }

      const targetUrl = `${canvasUrl}${path}`;

      if (authenticationStore.isLoggedIn) {
        if (userStore?.currentSecretId) {
          KnoxersManager.save(userStore.currentSecretId);
        }

        let finalUrl = targetUrl;
        if (isLocalhost()) {
          const authData = KnoxersManager.getAuthDataAsUrlParam();
          if (authData) {
            const separator = targetUrl.includes('?') ? '&' : '?';
            finalUrl = `${targetUrl}${separator}auth=${authData}`;
          }
        }

        window.location.replace(finalUrl);
      } else {
        const returnUrl = encodeURIComponent(targetUrl);
        history.push(`/login?returnUrl=${returnUrl}`);
      }
    }, [authenticationStore, userStore, history]);

    return null;
  });
}
